
import { RevLink } from '@ds/components/Link'
import { RevModal } from '@ds/components/Modal'
import { openModal } from '@ds/components/ModalBase'
import { IconInfo } from '@ds/icons/IconInfo'
import { mapGetters } from 'vuex'

import { MODAL_NAMES } from '@config/constants'
import { ROUTES } from '@router'
import { trackClick } from '@tracking/events'

import { COUNTRIES_WITH_REVIEWS_LEGAL_MODAL } from './ReviewsLegalModal.constants'
import translations from './ReviewsLegalModal.translations'

export default {
  components: {
    RevModal,
    IconInfo,
    RevLink,
  },
  computed: {
    ...mapGetters({
      country: 'config/country',
    }),
    translations: () => translations,
    modalName: () => MODAL_NAMES.REVIEWS.REVIEWS_LEGAL_INFORMATION,
    pdfLink() {
      return { name: ROUTES.PDF.CONSUMER }
    },
    hasLegalModal() {
      return COUNTRIES_WITH_REVIEWS_LEGAL_MODAL.includes(this.country)
    },
  },
  methods: {
    handleModalOpen() {
      trackClick({
        name: 'how_reviews_work',
        zone: 'details',
        page: this.$route.name,
      })
      openModal(this.modalName)
    },
  },
}
